import { TaskResponseState } from '@module/integration/task/model/TaskResponse';
import { PortCallFeeExportTaskStatusResponse } from '@module/evaluation/model/PortCallFeeExportTaskStatusResponse';
import { evaluationApi } from '../api';

export const taskApi = evaluationApi.injectEndpoints({
  endpoints: (build) => ({
    performRetryTask: build.mutation<{ state: TaskResponseState }, number>({
      query: (evaluationId) => ({
        url: `/${evaluationId}/retry-task`,
        method: 'POST'
      }),
      invalidatesTags: ['BudgetStatus']
    }),

    performGetTask: build.query<TaskResponseState, number>({
      query: (evaluationId) => ({
        url: `/${evaluationId}/get-task`,
        method: 'GET'
      })
    }),

    performGetPortCallFeeExportTask: build.query<
      PortCallFeeExportTaskStatusResponse,
      number
    >({
      query: (evaluationId) => ({
        url: `/${evaluationId}/port-call-fee-export-task`,
        method: 'GET'
      })
    })
  }),
  overrideExisting: false
});

export const {
  usePerformRetryTaskMutation,
  usePerformGetTaskQuery,
  usePerformGetPortCallFeeExportTaskQuery
} = taskApi;
